import Cookies from 'js-cookie'

const TokenKey = 'Bst-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getAllCookie() {
  return Cookies.get()
}


// WEBPACK FOOTER //
// ./src/util/auth.js